import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/CircularProgress": CircularProgress, "@mui/material/Box": Box } } });
export default ClientProvider;
